import { render, staticRenderFns } from "./SongSelect.vue?vue&type=template&id=db3fee64&scoped=true&"
import script from "./SongSelect.vue?vue&type=script&lang=js&"
export * from "./SongSelect.vue?vue&type=script&lang=js&"
import style0 from "./SongSelect.vue?vue&type=style&index=0&id=db3fee64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3fee64",
  null
  
)

export default component.exports